import request from '@/utils/request'

// 登录方法
export function login(data) {
	var params = ''
	for(let key in data){
		params += "&"+key+"="+data[key]
	}
	params = params.substring(1,params.length);
  return request({
    url: '/login?'+params,
    headers: {
      isToken: false
    },
    method: 'post'
    // data: data
  })
}

// 获取用户详细信息
export function captchaImage() {
  return request({
    url: '/captchaImage',
    method: 'get',
	headers: {
	  isToken: false
	}
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/app/personal/getInfo',
    method: 'get'
  })
}


// 退出方法
export function logout() {
  return request({
    url: '/app/personal/logout',
    method: 'post'
  })
}

